export default "__VITE_ASSET__BLPykIx9__"